// Mock data for Ayurvedic Medicine Portfolio System

export const mockMedicines = [
  {
    id: '1',
    name: 'Piles Care Kit',
    category: 'Digestive Health',
    price: 1299,
    originalPrice: 1599,
    image: 'https://images.unsplash.com/photo-1631549916768-4119b2e5f926?w=800&h=600&fit=crop',
    description: 'Complete Ayurvedic solution for piles and hemorrhoids relief',
    duration: '30 days course',
    productsIncluded: [
      'Piles Relief Tablets (60 tablets)',
      'Hemorrhoid Cream (50g)',
      'Triphala Churna (100g)',
      'Dietary Guidelines Chart'
    ],
    benefits: ['Reduces pain & swelling', 'Stops bleeding', 'Prevents recurrence', 'Improves digestion'],
    inStock: true,
    featured: true,
    rating: 4.8,
    reviews: 234
  },
  {
    id: '2',
    name: 'Gyno Care Kit',
    category: "Women's Health",
    price: 1499,
    originalPrice: 1899,
    image: 'https://images.unsplash.com/photo-1638202993928-7267aad84c31?w=800&h=600&fit=crop',
    description: 'Comprehensive women wellness kit for hormonal balance and reproductive health',
    duration: '45 days course',
    productsIncluded: [
      'Shatavari Capsules (60 caps)',
      'Ashoka Syrup (200ml)',
      'Hormone Balance Tablets (60 tabs)',
      'Women Wellness Guide'
    ],
    benefits: ['Hormonal balance', 'Regulates periods', 'Reduces cramps', 'Improves fertility'],
    inStock: true,
    featured: true,
    rating: 4.9,
    reviews: 456
  },
  {
    id: '3',
    name: 'IBS Relief Kit',
    category: 'Digestive Health',
    price: 1199,
    originalPrice: 1499,
    image: 'https://images.unsplash.com/photo-1769029174021-b305fa92f0ae?w=800&h=600&fit=crop',
    description: 'Natural solution for Irritable Bowel Syndrome and digestive disorders',
    duration: '60 days course',
    productsIncluded: [
      'Digestive Enzyme Tablets (90 tabs)',
      'Gut Health Capsules (60 caps)',
      'Probiotic Powder (100g)',
      'IBS Diet Plan'
    ],
    benefits: ['Relieves bloating', 'Reduces abdominal pain', 'Regulates bowel movements', 'Improves gut health'],
    inStock: true,
    featured: true,
    rating: 4.7,
    reviews: 312
  },
  {
    id: '4',
    name: 'Hair Fall Control Kit',
    category: 'Hair Care',
    price: 1399,
    originalPrice: 1799,
    image: 'https://images.unsplash.com/photo-1633179963355-44f57f194d54?w=800&h=600&fit=crop',
    description: 'Complete hair care solution to stop hair fall and promote hair growth',
    duration: '90 days course',
    productsIncluded: [
      'Hair Growth Tablets (90 tabs)',
      'Hair Oil with 21 herbs (200ml)',
      'Biotin Capsules (60 caps)',
      'Hair Care Guide'
    ],
    benefits: ['Stops hair fall', 'Promotes new growth', 'Strengthens roots', 'Adds shine & volume'],
    inStock: true,
    featured: true,
    rating: 4.8,
    reviews: 523
  },
  {
    id: '5',
    name: 'Skin Pigmentation Kit',
    category: 'Skin Care',
    price: 1599,
    originalPrice: 1999,
    image: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=800&h=600&fit=crop',
    description: 'Advanced solution for dark spots, melasma and uneven skin tone',
    duration: '60 days course',
    productsIncluded: [
      'Skin Brightening Tablets (60 tabs)',
      'Pigmentation Cream (50g)',
      'Vitamin C Serum (30ml)',
      'Sun Protection Guide'
    ],
    benefits: ['Reduces dark spots', 'Even skin tone', 'Natural glow', 'Prevents pigmentation'],
    inStock: true,
    featured: true,
    rating: 4.6,
    reviews: 289
  },
  {
    id: '6',
    name: 'Diabetes Management Kit',
    category: 'Chronic Care',
    price: 1699,
    originalPrice: 2199,
    image: 'https://images.unsplash.com/photo-1579154341796-0053da15f9d4?w=800&h=600&fit=crop',
    description: 'Natural blood sugar control and diabetes management solution',
    duration: '60 days course',
    productsIncluded: [
      'Sugar Control Tablets (90 tabs)',
      'Karela Jamun Juice (500ml)',
      'Methi Capsules (60 caps)',
      'Diabetic Diet Chart'
    ],
    benefits: ['Controls blood sugar', 'Improves insulin sensitivity', 'Reduces complications', 'Energy boost'],
    inStock: true,
    featured: false,
    rating: 4.7,
    reviews: 412
  },
  {
    id: '7',
    name: 'Joint Pain Relief Kit',
    category: 'Pain Management',
    price: 1499,
    originalPrice: 1899,
    image: 'https://images.unsplash.com/photo-1599058917212-d750089bc07e?w=800&h=600&fit=crop',
    description: 'Complete solution for arthritis, joint pain and inflammation',
    duration: '45 days course',
    productsIncluded: [
      'Joint Care Tablets (90 tabs)',
      'Pain Relief Oil (100ml)',
      'Calcium Magnesium Caps (60 caps)',
      'Exercise Guide'
    ],
    benefits: ['Reduces joint pain', 'Improves mobility', 'Anti-inflammatory', 'Strengthens bones'],
    inStock: true,
    featured: false,
    rating: 4.8,
    reviews: 367
  },
  {
    id: '8',
    name: 'Weight Loss Kit',
    category: 'Weight Management',
    price: 1799,
    originalPrice: 2299,
    image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=600&fit=crop',
    description: 'Natural weight loss solution with metabolism boosters',
    duration: '90 days course',
    productsIncluded: [
      'Fat Burner Capsules (90 caps)',
      'Detox Green Tea (100g)',
      'Garcinia Cambogia Extract (60 caps)',
      'Weight Loss Diet Plan'
    ],
    benefits: ['Burns fat naturally', 'Boosts metabolism', 'Reduces appetite', 'Sustained energy'],
    inStock: false,
    featured: false,
    rating: 4.5,
    reviews: 298
  },
  {
    id: '9',
    name: 'Immunity Booster Kit',
    category: 'Immunity',
    price: 999,
    originalPrice: 1299,
    image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=800&h=600&fit=crop',
    description: 'Strengthen your immune system naturally with powerful herbs',
    duration: '30 days course',
    productsIncluded: [
      'Giloy Tablets (60 tabs)',
      'Chyawanprash (500g)',
      'Tulsi Drops (30ml)',
      'Immunity Guide'
    ],
    benefits: ['Strong immunity', 'Fights infections', 'Respiratory health', 'Overall wellness'],
    inStock: true,
    featured: true,
    rating: 4.9,
    reviews: 678
  },
  {
    id: '10',
    name: 'Acidity & Gas Kit',
    category: 'Digestive Health',
    price: 899,
    originalPrice: 1199,
    image: 'https://images.unsplash.com/photo-1628771065518-0d82f1938462?w=800&h=600&fit=crop',
    description: 'Quick relief from acidity, gas and heartburn',
    duration: '30 days course',
    productsIncluded: [
      'Acidity Relief Tablets (60 tabs)',
      'Digestive Syrup (200ml)',
      'Ajwain Capsules (30 caps)',
      'Food Guidelines'
    ],
    benefits: ['Instant relief', 'Reduces acid reflux', 'Improves digestion', 'Prevents recurrence'],
    inStock: true,
    featured: false,
    rating: 4.6,
    reviews: 234
  },
  {
    id: '11',
    name: 'Stress & Anxiety Kit',
    category: 'Mental Wellness',
    price: 1299,
    originalPrice: 1699,
    image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&h=600&fit=crop',
    description: 'Natural stress relief and mental peace solution',
    duration: '45 days course',
    productsIncluded: [
      'Ashwagandha Capsules (60 caps)',
      'Brahmi Tablets (60 tabs)',
      'Calming Tea Blend (100g)',
      'Meditation Guide'
    ],
    benefits: ['Reduces stress', 'Calms mind', 'Better sleep', 'Improves focus'],
    inStock: true,
    featured: false,
    rating: 4.8,
    reviews: 445
  },
  {
    id: '12',
    name: 'Kidney Care Kit',
    category: 'Chronic Care',
    price: 1899,
    originalPrice: 2399,
    image: 'https://images.unsplash.com/photo-1607619056574-7b8d3ee536b2?w=800&h=600&fit=crop',
    description: 'Complete kidney health and detoxification support',
    duration: '60 days course',
    productsIncluded: [
      'Kidney Care Tablets (90 tabs)',
      'Punarnava Syrup (200ml)',
      'Stone Dissolving Caps (60 caps)',
      'Kidney Diet Chart'
    ],
    benefits: ['Kidney detox', 'Prevents stones', 'Improves function', 'Reduces swelling'],
    inStock: true,
    featured: false,
    rating: 4.7,
    reviews: 189
  }
];

export const mockPractitioners = [
  {
    id: '1',
    name: 'Dr. Shalini',
    qualification: 'BAMS, M.D.',
    specialization: 'Gynecologist',
    experience: 10,
    image: 'https://plus.unsplash.com/premium_photo-1682089872205-dbbae3e4ba32?w=400&h=400&fit=crop',
    rating: 4.9,
    consultationFee: 600,
    availability: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    timeSlots: ['10:00 AM', '11:00 AM', '12:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM'],
    languages: ['Hindi', 'English'],
    about: 'Expert gynecologist specializing in women\'s health, hormonal balance, menstrual disorders and reproductive wellness through authentic Ayurvedic treatments.'
  },
  {
    id: '2',
    name: 'Dr. Jai Malik',
    qualification: 'M.S.',
    specialization: 'Proctologist',
    experience: 18,
    image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&h=400&fit=crop',
    rating: 4.8,
    consultationFee: 900,
    availability: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    timeSlots: ['9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '3:00 PM', '4:00 PM', '5:00 PM'],
    languages: ['Hindi', 'English', 'Punjabi'],
    about: 'Renowned proctologist specializing in treatment of piles, fistula, fissure and other ano-rectal conditions with proven Ayurvedic and surgical expertise.'
  },
  {
    id: '3',
    name: 'Dr. Anjali Sharma',
    qualification: 'BAMS, MD (Ayurveda)',
    specialization: 'Panchakarma & Detoxification',
    experience: 15,
    image: 'https://images.unsplash.com/photo-1614608682850-e0a6ed070742?w=400&h=400&fit=crop',
    rating: 4.8,
    consultationFee: 800,
    availability: ['Monday', 'Wednesday', 'Friday'],
    timeSlots: ['10:00 AM', '11:00 AM', '2:00 PM', '3:00 PM', '4:00 PM'],
    languages: ['Hindi', 'English'],
    about: 'Specialized in traditional Panchakarma treatments with 15 years of experience in holistic healing.'
  },
  {
    id: '4',
    name: 'Dr. Rajesh Kumar',
    qualification: 'BAMS, PhD (Ayurveda)',
    specialization: 'Chronic Diseases & Pain Management',
    experience: 20,
    image: 'https://images.unsplash.com/photo-1642975967602-653d378f3b5b?w=400&h=400&fit=crop',
    rating: 4.9,
    consultationFee: 1000,
    availability: ['Tuesday', 'Thursday', 'Saturday'],
    timeSlots: ['9:00 AM', '10:00 AM', '11:00 AM', '3:00 PM', '4:00 PM'],
    languages: ['Hindi', 'English', 'Sanskrit'],
    about: 'Expert in managing chronic conditions through Ayurvedic principles and personalized treatment plans.'
  },
  {
    id: '5',
    name: 'Dr. Priya Verma',
    qualification: 'BAMS, MD (Kayachikitsa)',
    specialization: 'Skin & Hair Care',
    experience: 12,
    image: 'https://images.unsplash.com/photo-1659353888906-adb3e0041693?w=400&h=400&fit=crop',
    rating: 4.7,
    consultationFee: 700,
    availability: ['Monday', 'Tuesday', 'Thursday', 'Saturday'],
    timeSlots: ['11:00 AM', '12:00 PM', '2:00 PM', '3:00 PM', '5:00 PM'],
    languages: ['Hindi', 'English'],
    about: 'Focused on natural beauty and wellness through Ayurvedic skincare and hair treatments.'
  },
  {
    id: '6',
    name: 'Dr. Vikram Patel',
    qualification: 'BAMS, MD (Panchakarma)',
    specialization: 'Digestive Disorders',
    experience: 18,
    image: 'https://images.unsplash.com/photo-1622253694242-abeb37a33e97?w=400&h=400&fit=crop',
    rating: 4.8,
    consultationFee: 900,
    availability: ['Wednesday', 'Friday', 'Saturday'],
    timeSlots: ['10:00 AM', '11:00 AM', '12:00 PM', '4:00 PM', '5:00 PM'],
    languages: ['Hindi', 'English', 'Gujarati'],
    about: 'Specialist in treating digestive and metabolic disorders through holistic Ayurvedic approach.'
  }
];

export const mockTreatments = [
  {
    id: '1',
    name: 'Abhyanga',
    category: 'Massage Therapy',
    duration: '60 minutes',
    price: 1500,
    image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&h=600&fit=crop',
    description: 'Full body therapeutic oil massage using herbal oils',
    benefits: ['Improves circulation', 'Reduces stress', 'Detoxifies body', 'Enhances skin glow'],
    procedure: 'Warm herbal oil massage performed in rhythmic strokes',
    recommended: 'Weekly for best results',
    featured: true
  },
  {
    id: '2',
    name: 'Shirodhara',
    category: 'Head Therapy',
    duration: '45 minutes',
    price: 2000,
    image: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&h=600&fit=crop',
    description: 'Continuous stream of warm oil on forehead for deep relaxation',
    benefits: ['Relieves stress', 'Improves sleep', 'Calms mind', 'Reduces headaches'],
    procedure: 'Gentle flow of medicated oil over the forehead',
    recommended: '7-14 sessions for chronic conditions',
    featured: true
  },
  {
    id: '3',
    name: 'Panchakarma',
    category: 'Detoxification',
    duration: '7-21 days',
    price: 15000,
    image: 'https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&h=600&fit=crop',
    description: 'Complete body detoxification and rejuvenation program',
    benefits: ['Deep detoxification', 'Immunity boost', 'Disease prevention', 'Rejuvenation'],
    procedure: 'Five purification procedures customized to individual needs',
    recommended: 'Once or twice a year',
    featured: true
  },
  {
    id: '4',
    name: 'Nasya',
    category: 'Nasal Therapy',
    duration: '30 minutes',
    price: 800,
    image: 'https://images.unsplash.com/photo-1512290923902-8a9f81dc236c?w=800&h=600&fit=crop',
    description: 'Nasal administration of medicated oils for sinus relief',
    benefits: ['Clears sinuses', 'Relieves headaches', 'Improves breathing', 'Enhances clarity'],
    procedure: 'Medicated oil drops administered through nostrils',
    recommended: '5-7 sessions',
    featured: false
  },
  {
    id: '5',
    name: 'Kati Basti',
    category: 'Pain Management',
    duration: '40 minutes',
    price: 1200,
    image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&h=600&fit=crop',
    description: 'Warm oil therapy for lower back pain relief',
    benefits: ['Relieves back pain', 'Strengthens spine', 'Improves mobility', 'Reduces inflammation'],
    procedure: 'Warm medicated oil pooled over lower back area',
    recommended: '7-14 sessions',
    featured: false
  },
  {
    id: '6',
    name: 'Udvartana',
    category: 'Weight Management',
    duration: '60 minutes',
    price: 1800,
    image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=600&fit=crop',
    description: 'Herbal powder massage for weight loss and cellulite reduction',
    benefits: ['Weight reduction', 'Improves skin tone', 'Boosts metabolism', 'Reduces cellulite'],
    procedure: 'Dry powder massage with upward strokes',
    recommended: '15-21 sessions',
    featured: true
  }
];

export const mockCategories = [
  { id: '1', name: 'Digestive Health', icon: 'Activity', count: 4 },
  { id: '2', name: "Women's Health", icon: 'Heart', count: 3 },
  { id: '3', name: 'Hair Care', icon: 'User', count: 1 },
  { id: '4', name: 'Skin Care', icon: 'Sparkles', count: 4 },
  { id: '5', name: 'Chronic Care', icon: 'Shield', count: 2 },
  { id: '6', name: 'Pain Management', icon: 'Zap', count: 1 },
  { id: '7', name: 'Weight Management', icon: 'TrendingDown', count: 1 },
  { id: '8', name: 'Immunity', icon: 'Shield', count: 1 },
  { id: '9', name: 'Mental Wellness', icon: 'Brain', count: 1 }
];

export const mockTestimonials = [
  {
    id: '1',
    name: 'Priya Singh',
    location: 'Mumbai',
    rating: 5,
    text: 'The Piles Care Kit completely cured my problem. I tried everything but this kit worked like magic. Highly recommended!',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop',
    treatment: 'Piles Care Kit'
  },
  {
    id: '2',
    name: 'Rahul Mehta',
    location: 'Delhi',
    rating: 5,
    text: 'Hair Fall Control Kit stopped my hair loss completely. After 3 months I can see new hair growth. Amazing results!',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop',
    treatment: 'Hair Fall Control Kit'
  },
  {
    id: '3',
    name: 'Anita Desai',
    location: 'Bangalore',
    rating: 5,
    text: 'Gyno Care Kit helped me balance my hormones naturally. No more irregular periods. Thank you Aatreya Herbals!',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop',
    treatment: 'Gyno Care Kit'
  },
  {
    id: '4',
    name: 'Sandeep Kumar',
    location: 'Pune',
    rating: 5,
    text: 'IBS Relief Kit has changed my life. No more bloating and pain. I can eat normally now after years of suffering.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop',
    treatment: 'IBS Relief Kit'
  },
  {
    id: '5',
    name: 'Meera Iyer',
    location: 'Chennai',
    rating: 5,
    text: 'The Skin Pigmentation Kit cleared my dark spots within 2 months. My skin looks even and radiant now. Absolutely worth it!',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop',
    treatment: 'Skin Pigmentation Kit'
  },
  {
    id: '6',
    name: 'Arjun Reddy',
    location: 'Hyderabad',
    rating: 5,
    text: 'Immunity Booster Kit kept my whole family healthy this season. No more frequent colds. Great natural product!',
    image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=100&h=100&fit=crop',
    treatment: 'Immunity Booster Kit'
  },
  {
    id: '7',
    name: 'Kavita Joshi',
    location: 'Jaipur',
    rating: 5,
    text: 'Consulted Dr. Shalini for my hormonal issues. Her guidance and the Gyno kit worked wonders. Very caring doctor.',
    image: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=100&h=100&fit=crop',
    treatment: 'Doctor Consultation'
  },
  {
    id: '8',
    name: 'Rohit Sharma',
    location: 'Lucknow',
    rating: 5,
    text: 'The Joint Pain Relief Kit reduced my knee pain significantly. I can walk and climb stairs comfortably now.',
    image: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=100&h=100&fit=crop',
    treatment: 'Joint Pain Relief Kit'
  }
];

export const mockCart = [];

export const mockAppointments = [];

export const mockOrders = [];
